import light from './light';

export default {
  light,
  dark: light,
};
